import React, { useEffect, useRef, useState } from "react";
import styles from "./Instructions.module.css";
import { List, Modal, Switch } from "antd";
import { Collapse, Divider } from "antd";
import { FaPlayCircle, FaRegCalendarAlt, FaStopCircle, FaTrash } from "react-icons/fa";
import { GoPlus } from "react-icons/go";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import image_sample from "../../../../assets/instructions.png";
// import LocationMiddleware from "../../store/Middlewares/LocationMiddleware";
import { useDispatch, useSelector } from "react-redux";
// import { IMG_URL } from "../../store/Apis";
// import AlertAction from "../../store/Actions/AlertActions";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { MdClear, MdOutlineTimer } from "react-icons/md";
import addImg from '../../../../assets/addImg.png';
import { AntdSubmit } from "../../../../components";
import { useGeolocated } from "react-geolocated";
import moment from "moment";
import ActiveJobsMiddleware from "../../../../store/Middlewares/ActiveJobsMiddleware";
import TimeINTimeOUTActions from "../../../../store/Actions/TimeINTimeOUTActions";
import StartJobMiddleware from "../../../../store/Middlewares/StartJobMiddleware";
import AlertAction from "../../../../store/Actions/AlertActions";
import { IMG_URL } from "../../../../store/Apis";



const Instructions = (data) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLunchModalOpen, setIsLunchModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const Data = data?.data?.state
  const dispatch = useDispatch();

  const [InstructionList, setInstructionList] = useState([]);
  const [ShowItem, setShowItem] = useState(null);
  const [ShowSubItem, setShowSubItem] = useState(null);

  const CheckListData = useSelector(
    (state) => state.EditChecklistReducer.Checklist
  );
  const hiddenFileInput = React.useRef();
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const hiddenLunchFileInput = React.useRef();
  const handleLunchClick = (event) => {
    hiddenLunchFileInput.current.click();
  };

  const [Toggle, setToggle] = useState(true);
  const { Panel } = Collapse;
  const navigate = useNavigate();
  const videoRef = useRef(null);

  useEffect(() => {
    getActiveAndPastJobDetails();
    getLanguage();
    getLocation();
    // getLiveLocation();
  }, [])


  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language);
    } catch (e) {
    }
  };

  const { t, i18n } = useTranslation();
  const [refresh, setrefresh] = useState(false);
  const [SelectedItemIndex, setSelectedItemIndex] = useState(null);
  const [mediaType, setmediaType] = useState(null)
  const StartTime = useSelector((state) => state.TimeINTimeOUTReducer.StartTime)
  // const [StartTime, setStartTime] = useState(null);
  const TimeText = useSelector((state) => state.TimeINTimeOUTReducer.TimeText)
  // const [TimeText, setTimeText] = useState(t('Time In'));
  const BreakTime = useSelector((state) => state.TimeINTimeOUTReducer.BreakTime)
  // const [BreakTime, setBreakTime] = useState(null);
  const BreakText = useSelector((state) => state.TimeINTimeOUTReducer.BreakText)
  // const [BreakText, setBreakText] = useState(t('Break In'));
  const [Address, setAddress] = useState('23, Building 12, YZ Road, NY, USA');
  const [ShowPlayButon, setShowPlayButon] = useState(false);
  const [ModalVisible, setModalVisible] = useState(false);
  const [BreakModalVisible, setBreakModalVisible] = useState(false);
  const [GPSModalVisible, setGPSModalVisible] = useState(false);
  const Play = useSelector((state) => state.TimeINTimeOUTReducer.Play)
  // const [Play, setPlay] = useState(false);
  const Break = useSelector((state) => state.TimeINTimeOUTReducer.Break)
  // const [Break, setBreak] = useState(false);
  const [alldata, setAllData] = useState([]);
  const [openItem, setopenItem] = useState(null);
  const [openSubItem, setopenSubItem] = useState(null);
  const pickImage = useSelector((state) => state.TimeINTimeOUTReducer.pickImage)
  // const [pickImage, setpickImage] = useState(null);
  const lunchAfterImage = useSelector((state) => state.TimeINTimeOUTReducer.lunchAfterImage)
  // const [lunchAfterImage, setlunchAfterImage] = useState(null);
  const [cords, setCords] = useState(null);
  const datamessage = useSelector((state) => state.TimeINTimeOUTReducer.datamessage)
  // const [datamessage, setDatamessage] = useState(null);
  const ActiveAndPastJobDetails = useSelector(
    state =>
      state.ActiveAndPastJobDetailsReducer.ActiveAndPastJobDetailsList
        ?.checklist,
  );

  const ActiveJobStatus = useSelector(
    state =>
      state.ActiveAndPastJobDetailsReducer.ActiveAndPastJobDetailsList
  );
  
  const getActiveAndPastJobDetails = () => {
    dispatch(ActiveJobsMiddleware.getActiveAndPastJobDetails(Data?.id))
    .then(data => {
      if(ActiveJobStatus?.time_in){
        dispatch(TimeINTimeOUTActions.setTimeIN(moment(ActiveJobStatus?.time_in).format('hh:mm A')))
          dispatch(TimeINTimeOUTActions.setWorkIN('Time Out'))
          dispatch(TimeINTimeOUTActions.setPlay(true))
          dispatch(TimeINTimeOUTActions.setDataMessage('Job started successfully'))
          setModalVisible(false);
      }else {
        dispatch(TimeINTimeOUTActions.setTimeInImage(null))
        dispatch(TimeINTimeOUTActions.setLunchAfterImage(null))
        dispatch(TimeINTimeOUTActions.setTimeIN(null))
        dispatch(TimeINTimeOUTActions.setWorkIN('Time In'))
        dispatch(TimeINTimeOUTActions.setPlay(false))
        dispatch(TimeINTimeOUTActions.setDataMessage(null))
        dispatch(TimeINTimeOUTActions.setBreak(false))
        dispatch(TimeINTimeOUTActions.setBreakStartTime(null))
        dispatch(TimeINTimeOUTActions.setBreakIN('Break In'))
      }
      if(ActiveJobStatus?.break_out){
        dispatch(TimeINTimeOUTActions.setDataMessage('Lunch time out successfully'))
          dispatch(TimeINTimeOUTActions.setBreakStartTime(moment(ActiveJobStatus?.break_out).format('hh:mm A')))
          dispatch(TimeINTimeOUTActions.setBreakIN('Break Out'))
          dispatch(TimeINTimeOUTActions.setBreak(true))
          setBreakModalVisible(false);
      }else{
        if(ActiveJobStatus?.break_in){
          dispatch(TimeINTimeOUTActions.setBreak(true))
          dispatch(TimeINTimeOUTActions.setBreakStartTime(moment(ActiveJobStatus?.break_in).format('hh:mm A')))
          dispatch(TimeINTimeOUTActions.setBreakIN('Break Out'))
        }
      }
    })
    .catch(error => console.log(error));
  };
  console.log('cords', cords)
  console.log('pickImage', pickImage)

  const onHandleUpload = () => {
    console.log('onHandleUpload')
    if (!pickImage) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: 'Please Select Picture' }))
      // Alert.alert('Please Select Picture');
      return;
    } else if (!cords) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: 'Location not found.' }))
    } else {
      let userData = {
        job_id: Data?.id,
        pickImage: pickImage,
        // mediaType: mediaType,
        latitude: cords?.latitude,
        longitude: cords?.longitude,
      };
      console.log('userData', userData)
      dispatch(StartJobMiddleware.startJob(userData))
        .then(data => {
          dispatch(AlertAction.ShowAlert({ type: "success", message: data?.message }))
          // Alert.alert('Note', data?.message);
          dispatch(TimeINTimeOUTActions.setTimeIN(moment().format('hh:mm A')))
          // setStartTime(moment().format('hh:mm A'));
          dispatch(TimeINTimeOUTActions.setWorkIN('Time Out'))
          // setTimeText(t('Time Out'));
          dispatch(TimeINTimeOUTActions.setPlay(true))
          // setPlay(true);
          dispatch(TimeINTimeOUTActions.setDataMessage(data?.message))
          // setDatamessage(data?.message);
          setIsModalOpen(false);
        })
        .catch(err => {
          dispatch(AlertAction.ShowAlert({ type: "error", message: err }))
        });
    }
  };

  const handleBreakIn = () => {
    let userData = {
      job_id: Data?.id,
      latitude: cords?.latitude,
      longitude: cords?.longitude,
    };
    dispatch(StartJobMiddleware.breakIn(userData))
      .then(data => {
        dispatch(AlertAction.ShowAlert({ type: "success", message: data?.message }))
        dispatch(TimeINTimeOUTActions.setBreak(true))
        // setBreak(true);
        dispatch(TimeINTimeOUTActions.setBreakStartTime(moment().format('hh:mm A')))
        // setBreakTime(moment().format('hh:mm A'));
        dispatch(TimeINTimeOUTActions.setBreakIN('Break Out'))
        // setBreakText(t('Break Out'));
      })
      .catch(err => {
        console.log(err);
      });

    // setGPSModalVisible(true);
    // setTimeout(() => {
    //   setGPSModalVisible(false);
    // }, 1000);
  };

  const handleBreakOut = () => {
    if (!lunchAfterImage) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: 'Please Select Picture' }))
      // Alert.alert('Please Select Picture');
      return;
    } else {
      let userData = {
        job_id: Data?.id,
        pickImage: lunchAfterImage,
        latitude: cords?.latitude,
        longitude: cords?.longitude,
      };
      dispatch(StartJobMiddleware.breakOut(userData))
        .then(data => {
          dispatch(AlertAction.ShowAlert({ type: "success", message: data?.message }))
          dispatch(TimeINTimeOUTActions.setDataMessage(data?.message))
          // setDatamessage(data?.message);
          dispatch(TimeINTimeOUTActions.setBreakStartTime(moment().format('hh:mm A')))
          // setBreakTime(moment().format('hh:mm A'));
          dispatch(TimeINTimeOUTActions.setBreakIN('Break Out'))
          // setBreakText('Break Out');
          dispatch(TimeINTimeOUTActions.setBreak(true))
          // setBreak(true);
          setIsLunchModalOpen(false);
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  const onHandleChange = () => {
    console.log('=========', Break)
    if (Break == false) {
      handleBreakIn();
    } else {
      setIsLunchModalOpen(true);
    }
  };

  const getLocation = () => {
    if (!navigator.geolocation) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: 'Geolocation is not supported by your browser' }))
    } else {
      navigator.geolocation.getCurrentPosition((position) => {
        let getCords = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };
        setCords(getCords);
      }, () => {
        dispatch(AlertAction.ShowAlert({ type: "error", message: 'Unable to retrieve your location . Please Enable your location.' }))
      });
    }
  }

  const renderDropdownItem = (item, index) => {
    return (
      <div className={styles.inner_dropdown_view}>
        <div style={{ width: '80%' }}>
          <div>
            <text className={styles.dropdown_text}>{item?.name}</text>
          </div>
          <div style={{ width: '100%', marginTop: '20px' }}>
            <text style={{ width: '100%' }} className={styles.dropdown_text}>{item?.description}</text>
          </div>
        </div>
        {item?.attachment ? (
          <img src={IMG_URL + item?.attachment} className={styles.image} />
        ) : null}
      </div>
    );
  };

  const renderItem = (item, index) => {
    return (
      <div className={styles.middle_view}>
        <Collapse size="large" bordered={false} className={styles.dropdown}>
          <Panel
            showArrow={false}
            header={
              <div className={styles.flex}>
                <div className={styles.flexB}>
                  {Toggle?.id != item?.id ? (
                    <IoIosArrowDown
                      className={styles.arrow_icon}
                      color="#ffff"
                      onClick={() => setToggle(item)}
                    />
                  ) : (
                    <IoIosArrowUp
                      className={styles.arrow_icon}
                      color="#ffff"
                      onClick={() => setToggle(null)}
                    />
                  )}
                  <text className={styles.heading}>{item?.name}</text>
                </div>

                <div className={styles.flexC}>
                  {/* <GoPlus
                    className={styles.icon}
                    color="#ffff"
                    onClick={() => navigate("/contractorHome/Location/CreateChecklist", { state: item })}
                  /> */}
                  {/* <FaTrash
                    //    onClick={() => onPressDelete(index, item?.id)}
                    className={styles.icon}
                    color="#ffff"
                  /> */}
                  {/* <Switch
                    defaultChecked
                    style={{ backgroundColor: Toggle ? "#f6921e" : "#787887" }}
                    onChange={() => setToggle(!Toggle)}
                  /> */}
                </div>
              </div>
            }
            key="1"
            className={styles.dropdown_header}
          >
            <List dataSource={item?.items} renderItem={renderDropdownItem} />
          </Panel>
        </Collapse>
      </div>
    );
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.head}>
        <div className={styles.rowOne}>
          <div className={styles.colLeft}>{Data?.location?.address}</div>
          <div className={styles.colRight}>
            <p>{
              Data?.start_time
                ? moment('01 jan 1947 ' + Data?.start_time).format(' hh:mm A')
                : ''
            }</p>
            <MdOutlineTimer className={styles.clockIcon} />
          </div>
        </div>
        <div className={styles.rowTwo}>
          <FaRegCalendarAlt className={styles.calIcon} />
          <p>{moment(Data?.date).format('MMM-DD-YYYY')}</p>
        </div>
      </div>

      <List dataSource={ActiveAndPastJobDetails} renderItem={renderItem} />
      <div className={styles.btns}>
        {ActiveAndPastJobDetails?.length > 0 ?
          // <button className={styles.btn} onClick={showModal}>
          <button className={styles.btn} onClick={() => {
            let time = (moment(Data?.start_time, "HH:mm:ss").format('HH:mm:ss'))
            let date = Data?.date + '' + time
            if (moment().format('YYYY-MM-DDHH:mm:ss') > date) {
              if (Play == true) {

                if (window.confirm('Have you updated inventory?')) {
                  let EndTime = moment().format('hh:mm A');
                  navigate('/checklist', {
                    state: {
                      job_id: Data?.id,
                      startTime: StartTime,
                      endTime: EndTime,
                      beforeImage: pickImage,
                      afterLunch: lunchAfterImage,
                    }
                  });
                }
              } else {
                showModal()
              }
            }
            else {
              dispatch(AlertAction.ShowAlert({ type: "error", message: 'You can not start the job before the decided date and time' }))
              // Alert.alert('Note', 'You can not start the job before the decided date and time')
            }
          }}>
            {Play ?
              <FaStopCircle className={styles.playIcon} /> :
              <FaPlayCircle className={styles.playIcon} />
            }


            <div className={styles.btnTxt}>
              <span>{TimeText}</span>
              <p>{StartTime ? StartTime : moment().format('hh:mm A')}</p>
            </div>
          </button>
          : null}


        {ActiveAndPastJobDetails?.length > 0 ?
          <button className={styles.btn} onClick={() => {
            if (datamessage == 'Job started successfully') {
              onHandleChange();
            } else if (datamessage == 'Lunch time out successfully') {
              // eslint-disable-next-line no-unused-expressions
              null
            }
          }}>
            {Break ?
              <FaStopCircle className={styles.playIcon} /> :
              <FaPlayCircle className={styles.playIcon} />
            }
            <div className={styles.btnTxt}>
              <span>{BreakText}</span>
              <p>{BreakTime ? BreakTime : moment().format('hh:mm A')}</p>
            </div>
          </button>
          : null}
      </div>
      <Modal
        className="modalStyle"
        style={{
          border: "2px solid #f6921e",
          backgroundColor: "#0F0F0F",
          borderRadius: "10px",
        }}
        closable={false}
        footer={null}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      // width={700}
      >
        <div style={{ display: "flex", justifyContent: "right" }} >
          <MdClear style={{ cursor: "pointer" }} color="#f6921e" size={25} onClick={handleCancel} />
        </div>
        <div className={styles.content}>
          <div className={styles.modalHead}>
            <h1>Please Upload A Photo / Video</h1>
            <p>Before Start Task</p>
          </div>
          <div className={styles.modalImg}>
            {pickImage?.type?.match("video/*") || pickImage?.type == "video" ?
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <video style={{ width: '100%' }} ref={videoRef} onBlur={() => videoRef.current.pause()} controls src={pickImage ? URL.createObjectURL(pickImage) : addImg} onClick={() => handleClick()} ></video>
              </div>
              :
              <img src={pickImage ? URL.createObjectURL(pickImage) : addImg} onClick={() => handleClick()} />
            }
          </div>
          <input
            type="file"
            accept="image/*,video/*"
            onChange={(e) => { dispatch(TimeINTimeOUTActions.setTimeInImage(e.target.files[0])) }}
            ref={hiddenFileInput}
            style={{ display: "none" }}
          />
          <div className={styles.modalBtns}>
            <AntdSubmit text={'Upload'} onClick={() => onHandleUpload()} buttonStyle={{ margin: '15px 0px', height: '60px', width: '100%' }} />
          </div>
        </div>
      </Modal>

      <Modal
        className="modalStyle"
        style={{
          border: "2px solid #f6921e",
          backgroundColor: "#0F0F0F",
          borderRadius: "10px",
        }}
        closable={false}
        footer={null}
        open={isLunchModalOpen}
        onOk={() => setIsLunchModalOpen(false)}
        onCancel={() => setIsLunchModalOpen(false)}
      // width={700}
      >
        <div style={{ display: "flex", justifyContent: "right" }} >
          <MdClear style={{ cursor: "pointer" }} color="#f6921e" size={25} onClick={() => setIsLunchModalOpen(false)} />
        </div>
        <div className={styles.content}>
          <div className={styles.modalHead}>
            <h1>Please Upload A Photo</h1>
            <p>{t('Please Upload A Picture of Meal at the time of Break Out')}</p>
          </div>
          <div className={styles.modalImg}>
            {/* {lunchAfterImage?.type.match("video/*") ? 
            <iframe src={lunchAfterImage ? URL.createObjectURL(lunchAfterImage) : addImg} onClick={() => handleClick()} ></iframe> 
            : */}
            <img src={lunchAfterImage ? URL.createObjectURL(lunchAfterImage) : addImg} onClick={() => handleLunchClick()} />
            {/* } */}
          </div>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => { dispatch(TimeINTimeOUTActions.setLunchAfterImage(e.target.files[0])) }}
            ref={hiddenLunchFileInput}
            style={{ display: "none" }}
          />
          <div className={styles.modalBtns}>
            <AntdSubmit text={'Upload'} onClick={() => handleBreakOut()} buttonStyle={{ margin: '15px 0px', height: '60px', width: '100%' }} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Instructions;
